<fieldset [formGroup]="group" class="in-one-column">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>

  <!-- flavorTypes -->

  <mat-form-field>
    <app-easy-select
      formControlName="flavorTypes"
      [label]="TITLE + 'FLAVOR_TYPES' | translate"
      [translatePrefixForSelected]="'PRODUCTS.FLAVOR_TYPE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [multiple]="true"
      [options]="flavorType | toSelectOption: 'PRODUCTS.FLAVOR_TYPE.':true"
    >
    </app-easy-select>
  </mat-form-field>

  <!-- basedOnSoy -->

  <mat-form-field>
    <app-easy-checkbox
      formControlName="basedOnSoy"
      [label]="TITLE + 'BASED_ON_SOY' | translate"
      (ngModelChange)="onBasedOnSoyChanged($event)"
    ></app-easy-checkbox>
  </mat-form-field>

  <!-- proteinContentIsOver28PercentByWeight -->

  <mat-form-field *ngIf="getCtrl('proteinContentIsOver28PercentByWeight')">
    <app-easy-checkbox
      formControlName="proteinContentIsOver28PercentByWeight"
      [label]="TITLE + 'PROTEIN_CONTENT' | translate"
    ></app-easy-checkbox>
  </mat-form-field>

  <!-- containsMetilXantin -->

  <mat-form-field>
    <app-easy-checkbox
      formControlName="containsMetilXantin"
      [label]="TITLE + 'CONTAINS_METIL_XANTIN' | translate"
      (ngModelChange)="onContainsMetilXantinChanged($event)"
    ></app-easy-checkbox>
  </mat-form-field>

  <!-- metilXantinAmount -->

  <mat-form-field *ngIf="getCtrl('metilXantinAmount')">
    <app-easy-input
      formControlName="metilXantinAmount"
      [label]="TITLE + 'METIL_XANTIN_AMOUNT' | translate"
      type="number"
      step="1"
      min="0"
      max="100"
    >
    </app-easy-input>
  </mat-form-field>

  <!-- containsTaurinOrGingsengOrLarginin -->

  <mat-form-field>
    <app-easy-checkbox
      formControlName="containsTaurinOrGingsengOrLarginin"
      [label]="TITLE + 'CONTAINS_TAURIN_OR_GINGSENG_OR_LARGININ' | translate"
    ></app-easy-checkbox>
  </mat-form-field>

  <!-- containsFruitsOrVegetablesAtLeast50Percent -->

  <mat-form-field>
    <app-easy-checkbox
      formControlName="containsFruitsOrVegetablesAtLeast50Percent"
      [label]="
        TITLE + 'CONTAINS_FRUITS_OR_VEGETABLES_AT_LEAST50_PERCENT' | translate
      "
    ></app-easy-checkbox>
  </mat-form-field>

  <!-- sugar fields -->

  <mat-form-field *ngIf="getCtrl('containsAddedSugar')">
    <app-easy-checkbox
      formControlName="containsAddedSugar"
      [label]="CONTAINS_ADDED_SUGAR | translate"
      (ngModelChange)="onSweetenerOrSugarChangedNonAlcoholic(true)"
    ></app-easy-checkbox>
  </mat-form-field>

  <mat-form-field *ngIf="getCtrl('containsAddedSweetener')">
    <app-easy-checkbox
      formControlName="containsAddedSweetener"
      [label]="CONTAINS_ADDED_SWEETENER | translate"
      (ngModelChange)="onSweetenerOrSugarChangedNonAlcoholic(true)"
    ></app-easy-checkbox>
  </mat-form-field>

  <mat-form-field *ngIf="getCtrl('sugarContentType')">
    <app-easy-select
      formControlName="sugarContentType"
      [label]="SUGAR_CONTENT_TYPE | translate"
      [translatePrefixForSelected]="'PRODUCTS.SUGAR_CONTENT_TYPE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="nonAlcoholicSugarContentType"
    >
    </app-easy-select>
  </mat-form-field>

  <!-- !sugar fields -->
</fieldset>
